import type { SpreadPoint } from "../definitions/SpreadPoint";

/**
 * Fixture used by `MockApiTransport` (`?mock=1`) — a month of EUR/USD spread
 * average readings shaped to match the reference screenshot: jagged daily
 * values mostly between ~0.27 and ~0.51, with a sharp spike on the final day.
 */
const RAW: [string, number][] = [
  ["2026-07-10", 0.4],
  ["2026-07-11", 0.42],
  ["2026-07-13", 0.51],
  ["2026-07-15", 0.31],
  ["2026-07-16", 0.36],
  ["2026-07-18", 0.28],
  ["2026-07-20", 0.46],
  ["2026-07-21", 0.31],
  ["2026-07-22", 0.36],
  ["2026-07-24", 0.27],
  ["2026-07-25", 0.34],
  ["2026-07-26", 0.58],
  ["2026-07-27", 0.45],
  ["2026-07-28", 0.39],
  ["2026-07-29", 0.39],
  ["2026-07-30", 0.34],
  ["2026-07-31", 0.32],
  ["2026-08-01", 0.31],
  ["2026-08-03", 0.39],
  ["2026-08-04", 0.33],
  ["2026-08-05", 0.3],
  ["2026-08-06", 0.41],
  ["2026-08-07", 0.33],
  ["2026-08-08", 0.3],
  ["2026-08-09", 0.72],
];

export const mockSpreadData: SpreadPoint[] = RAW.map(([date, value]) => [
  Date.parse(`${date}T00:00:00Z`),
  value,
]);
